module.exports = __webpack_public_path__ + "static/media/foto_03.2cf68539.jpg";